import React from 'react';
import { useGetPointHistories } from 'hooks/PointHistoryHooks';
import dayjs from 'dayjs';

const EXPIRY = 7;

const useMyPoint = (userId) => {
  /* ===== Variables ===== */
  // NOTE: 쿼리
  const query = {
    user_id: userId,
    type: '["EARNED", "REFUNDED"]',
  };
  // NOTE: 쿼리 옵션
  const options = {
    select: (res) => {
      const { status, data } = res;

      if (status !== 200) return [];
      else return data;
    },
    enabled: !!userId,
    initialData: [],
  };

  const EXPIRY_DATE = dayjs().startOf('day').unix();

  /**
   * SECTION 포인트 데이터
   * --
   */
  const { data: PointHistories } = useGetPointHistories(
    {
      ...query,
    },
    { ...options, enabled: !!userId }
  );

  const newPointHistory = React.useMemo(() => {
    const nowDateUnix = dayjs().unix();
    if (!PointHistories.length)
      return {
        useable: 0,
        expiry: 0,
        total: 0,
      };

    return PointHistories.reduce(
      (acc, cur) => {
        const { point, use_point, expired_date } = cur;

        acc['total'] += point;

        const useablePoint = nowDateUnix > expired_date ? 0 : point - use_point;

        acc['useable'] += useablePoint;

        // 만료예정인지 체크
        const expDay = dayjs
          .unix(expired_date)
          .diff(dayjs.unix(EXPIRY_DATE), 'day');

        if (expDay >= 0 && expDay <= EXPIRY) {
          acc['expiry'] += useablePoint;
        }

        return acc;
      },
      { useable: 0, expiry: 0, total: 0 }
    );
    // eslint-disable-next-line
  }, [PointHistories]);

  return newPointHistory;
};

export default useMyPoint;
